/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sujay's Portfolio",
  description:
    "Welcome to my digital space where technology meets creativity, showcasing a journey of code and innovation. I'm Sujay Kadam, a passionate Software Engineer and Developer on a mission to craft meaningful digital experiences. Explore and discover the intersection of my skills, projects, and the art of problem-solving.",
  og: {
    title: "Sujay Kadam Portfolio",
    type: "website",
    url: "https://sujaykadam.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Sujay Kadam",
  logo_name: "SujayKadam",
  subTitle:
    "Welcome to my digital space where technology meets creativity, showcasing a journey of code and innovation. I'm Sujay Kadam, a passionate Software Engineer and Developer on a mission to craft meaningful digital experiences. Explore and discover the intersection of my skills, projects, and the art of problem-solving.",
  resumeLink:
    "https://drive.google.com/file/d/1ftaSwGaj6rhbNApM0lD2EqrhhxgJyYKz/view?usp=sharing",
  portfolio_repository:
    "https://drive.google.com/file/d/1ftaSwGaj6rhbNApM0lD2EqrhhxgJyYKz/view?usp=sharing",
  githubProfile: "https://github.com/sujaykadam",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "Github",
    link: "https://github.com/sujaykadam",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sujay-kadam/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:skadam14@asu.edu",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ I craft digital experiences that seamlessly blend creativity and functionality.",
        "⚡ On the front end, I build responsive websites using React-Redux, Next, Vue, Nuxt and style the UI with Tailwind CSS, Bootstrap, Chakra UI.",
        "⚡ To serve these applications with data, I develop robust REST APIs with Node.js, Express, Flask, Spring Boot and GraphQL APIs with Apollo GQL Server.",
        "⚡ Essentially, I transform ideas into dynamic, user-centric digital solutions that work harmoniously across the entire spectrum of web development.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "devicon:typescript",
          style: {
            backgroundColor: "transparent",
            color: "#3178C6",
          },
        },
        {
          skillName: "Pyhton",
          fontAwesomeClassname: "devicon:python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java-wordmark",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "skill-icons:redux",
          style: {
            color: "#764ABC",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "devicon:nextjs",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "VueJS",
          fontAwesomeClassname: "devicon:vuejs",
          style: {
            color: "#4FC08D",
          },
        },
        {
          skillName: "NuxtJS",
          fontAwesomeClassname: "vscode-icons:file-type-nuxt",
          style: {
            color: "#00DC82",
          },
        },
        {
          skillName: "Tailwind CSS",
          fontAwesomeClassname: "devicon:tailwindcss",
          style: {
            color: "#06B6D4",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "devicon:bootstrap",
          style: {
            color: "#7952B3",
          },
        },
        {
          skillName: "Chakra UI",
          fontAwesomeClassname: "simple-icons:chakraui",
          style: {
            color: "#319795",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "vscode-icons:file-type-node",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Express JS",
          fontAwesomeClassname: "devicon:express",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Apollo GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E10098",
          },
        },
        {
          skillName: "Prisma ORM",
          fontAwesomeClassname: "skill-icons:prisma",
          style: {
            color: "#2D3748",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "devicon:flask",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "bxl:spring-boot",
          style: {
            color: "#6DB33F",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ I expertly navigate GCP, AWS, and Azure to orchestrate scalable and resilient cloud infrastructures tailored to the applications needs.",
        "⚡ I simplify our work using Git to control versions, Ansible for automating tasks, and Terraform for turning infrastructure into code. This makes our deployment processes agile and super efficient.",
        "⚡ I handle a variety of databases like MongoDB, PostgreSQL, MySQL, and Supabase. My goal is to make sure our data storage and retrieval are smooth, keeping our applications running seamlessly.",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "SupaBase",
          fontAwesomeClassname: "devicon:supabase",
          style: {
            color: "#3FCF8E",
          },
        },

        {
          skillName: "Git",
          fontAwesomeClassname: "devicon:git",
          style: {
            color: "#F05032",
          },
        },
        {
          skillName: "Ansible",
          fontAwesomeClassname: "devicon:ansible",
          style: {
            color: "#EE0000",
          },
        },
        {
          skillName: "Terraform",
          fontAwesomeClassname: "devicon:terraform",
          style: {
            color: "#844FBA",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Mongo DB",
          fontAwesomeClassname: "skill-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "skill-icons:mysql-dark",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "devicon:postgresql",
          style: {
            color: "#4169E1",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/sujaykadam/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/sujaykadam",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@sujaykadam",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Arizona State University",
      subtitle: "Master of Computer Science",
      logo_path: "asu-logo.png",
      alt_name: "Arizona State University",
      duration: "2023 - 2025",
      descriptions: [
        "Relevant Coursework:",
        "Foundations of Algorithms, Artificial Intelligence, Statistical Learning Theory, Statistical Machine Learning",
        "Data Processing at Sale, Data Visualization, Applied Cryptography",
      ],
      website_link: "https://www.asu.edu/",
    },
    {
      title: "University of Mumbai",
      subtitle: "Bachelor of Information Technology Engineering",
      logo_path: "mumbai-uni.png",
      alt_name: "University of Mumbai",
      duration: "2017 - 2021",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ I was the Head of Organizing Committee of our college's tecnical events",
      ],
      website_link: "https://mu.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Microsoft Certified Azure Administrator Associate",
      subtitle: "-Microsoft",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://www.credly.com/badges/52c1b00d-2a00-4828-a457-7148c8971c00",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Microsoft Certified: Azure Fundamentals",
      subtitle: "-Microsoft",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://www.credly.com/badges/6b8e8c1f-c285-42e3-8134-3e4118ac4b12",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "The Complete Web Development Bootcamp",
      subtitle: "-Udemy",
      logo_path: "udemy-logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-509fa40e-f311-4ec1-8135-c538c61d9edd/",
      alt_name: "Udemy",
      color_code: "#B445FF",
    },
    {
      title: "AWS Fundamentals Specialization",
      subtitle: "-AWS",
      logo_path: "aws-logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/BUUGUC3NNRNA",
      alt_name: "AWS",
      color_code: "#232F3E",
    },
    {
      title: "Deep Learning",
      subtitle: "-DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/2EANDBWWKKM5",
      alt_name: "Deep Learning",
      color_code: "#00000099",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've thrived in roles ranging from Software Development at Yocket, optimizing user experiences, to TCS – Sony Pictures, where I excelled in enhancing click-through rates and web app visibility. With expertise in full-stack development and infrastructure management, my proficiency spans technologies like React, Next.js, Express, MongoDB, and more.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Software Development Engineer",
          company: "Yocket",
          company_url: "https://yocket.com/",
          logo_path: "yocket-logo.png",
          duration: "March 2022 - July 2023",
          location: "Mumbai, India",
          description:
            "I've been instrumental in enhancing user experiences through strategic measures: implementing feature flags for A/B testing, reducing bounce rates by 28%, and optimizing SQL for a 150ms faster response time. By automating regression testing using AWS and Bitbucket Pipelines, I significantly cut sprint durations. Additionally, my proficiency with Jest increased code coverage from 1% to 18%, ensuring robust testing. Resolving issues with an SMS service led to monthly cost savings of $360, while the incorporation of Google Auth streamlined sign-in processes, resulting in a weekly increase of 3000 new users.",
          color: "#0879bf",
        },
        {
          title: "Asst. Systems Engineer Trainee",
          company: "TCS Sony Pictures and Entertainment,",
          company_url: "https://tcs.com/",
          logo_path: "tcs-logo.jpg",
          duration: "July 2021 - April 2022",
          location: "Mumbai, India",
          description:
            "I improved user experiences by implementing a JWT-based authentication microservice, cutting repetitive logins by 43% during a migration to microservices with Java Spring Boot. Deploying a TensorFlow sentiment analysis model on Azure doubled the click-through rate for content recommendations. My pivotal role in optimizing the React components library and introducing Server-Side Rendering via Next.js raised SEO scores from the 60s to 80s, significantly enhancing web app discoverability. These contributions showcase my ability to drive meaningful enhancements in user engagement, content analysis, and online visibility.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Engineering Intern",
          company: "Lotpick Consulting Services",
          company_url: "https://www.lotpick.com/en/",
          logo_path: "lotpick-logo.jpg",
          duration: "June 2020 - Aug 2020",
          location: "Mumbai, India",
          description:
            "I played a crucial role in road safety by developing a real-time traffic violation detection web app, cutting violations by 400 daily in three months. Integrating a Flask API with a real-time object detection model improved license plate identification by 13%. Streamlining operations, I deployed a React-based Next JS app and Flask backend on AWS using Docker, saving 30 minutes of build time on on-premise servers. These achievements highlight my significant impact in leveraging technology for public safety and operational efficiency.",
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I specialize in utilizing a diverse range of cutting-edge technology tools for the creation and deployment of full-stack projects on web applications through cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "cd1d91cb723693516787771fc9afad3294ecb0689b9fcfcfe3ec7ad9ed744659=",
      name: "Autonomous Drone for Social Distancing Surveillance",
      createdAt: "2021-05-21T16:26:54Z",
      description:
        "This paper explores the application of autonomous drones for surveillance, balancing privacy concerns with safety priorities, focusing on monitoring social distancing protocols and intending to develop a tool for broader human behavior analysis.",
      url: "https://ieeexplore.ieee.org/document/9456213",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "sujay-dp.jpg",
    description:
      "Feel free to reach out to me on the social media mentioned below. I am always open to discussing new projects, creative ideas or opportunities to be part of your visions.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://sujaykadam.github.io/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "1151 S Forest Ave, Tempe, AZ",
    locality: "Tempe",
    country: "US",
    region: "Arizona",
    postalCode: "85281",
    streetAddress: "1151 S Forest Ave",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/tAdNvwJazTeok2dZA",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  certifications,
  competitiveSites,
  contactPageData,
  degrees,
  experience,
  greeting,
  projectsHeader,
  publications,
  publicationsHeader,
  seo,
  settings,
  skills,
  socialMediaLinks,
};
